export enum TransferItemModes {
  CategoriesAndProducts = "Kategorien und Produkte",
  OnlyProducts = "nur Produkte",
  OnlyCategories = "nur Kategorien"
}
